module.exports = __webpack_public_path__ + "static/media/abstrato-5.de0d6cb3.jpg";